import { gql } from "@apollo/client";

export const GET_PRODUCT_GROUPS = gql`
  query Menukaarten($vestiging_id: Int, $id: [Int], $naam: String, $idNaamApiId1: String, $pageSize: Int, $page: Int) {
    menukaarten(
      vestiging_id: $vestiging_id
      id: $id
      naam: $naam
      idNaamApiId1: $idNaamApiId1
      first: $pageSize
      page: $page
    ) {
      data {
        id
        naam
        vestiging_id
        sortkey
        apiId1
        blocked
        is_actief
      }
      paginatorInfo {
        perPage
        currentPage
        total
      }
    }
  }
`;
